export const PBS_TOOLTIP_OFFSET = {
  x: -10,
  y: -40,
};
